import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { clsx } from 'clsx';
import { formatDate } from '@utils/formatters';
import { formatCompact } from './dashboardHelpers';

const DashboardRecentTransactions = ({ recentTransactions }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-semibold text-gray-900 dark:text-white">Últimas Transações</h3>
          <p className="text-xs text-gray-400 mt-0.5">Este mês</p>
        </div>
        <Link to="/app/transactions">
          <button className="text-xs text-primary-600 hover:text-primary-700 font-medium">
            Ver todas →
          </button>
        </Link>
      </div>
      {recentTransactions.length > 0 ? (
        <div className="space-y-1">
          {recentTransactions.slice(0, 5).map(t => (
            <div key={t.transactionId}
              className="flex items-center gap-3 py-2 border-b border-gray-100 dark:border-gray-700 last:border-0">
              <div className={clsx(
                'w-8 h-8 rounded-lg flex-shrink-0 flex items-center justify-center',
                t.type === 'income' ? 'bg-emerald-100 dark:bg-emerald-900/30' : 'bg-red-100 dark:bg-red-900/30'
              )}>
                {t.type === 'income'
                  ? <ArrowUpRight size={15} className="text-emerald-600" />
                  : <ArrowDownRight size={15} className="text-red-600" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 dark:text-white truncate">{t.description}</p>
                <p className="text-xs text-gray-400">{formatDate(t.date)}</p>
              </div>
              <p className={clsx(
                'text-sm font-bold flex-shrink-0',
                t.type === 'income' ? 'text-emerald-600' : 'text-red-600'
              )}>
                {t.type === 'income' ? '+' : ''}{formatCompact(t.amount)}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="h-32 flex items-center justify-center text-gray-400 text-sm">
          Nenhuma transação no período
        </div>
      )}
    </div>
  );
};

export default DashboardRecentTransactions;
